<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12>
        <v-data-table :headers="headers" :items="institutions" :hide-actions="true" item-key="code" no-data-text="Список институтов пуст">
          <template v-slot:items="{ item: institution }">
            <td>{{ institution.code }}</td>
            <td>{{ institution.title[locale] }}</td>
            <td>{{ institution.abbreviation[locale] }}</td>
            <td>{{ institution.director ? institution.director['fullname'] : '' }}</td>
            <td class="text-xs-right">
              <v-btn flat icon title="Редактировать" color="primary" @click="editInstitution(institution)">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn flat icon title="Удалить" color="error">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-layout mt-3>
      <v-flex xs12 text-xs-right>
        <v-dialog v-model="institution.dialog" persistent max-width="600">
          <template v-slot:activator="{ on }">
            <v-btn color="info" v-on="on">Добавить</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Новый институт</span>
            </v-card-title>
            <v-card-text>
              <v-form v-model="institution.valid" ref="institutionForm">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field label="Полное название института" required v-model="institution.values.title" :counter="255" :rules="institution.rules.title" />
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field label="Аббревиатура" required v-model="institution.values.abbreviation" :counter="20" :rules="institution.rules.abbreviation" />
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field label="Код" required v-model="institution.values.code" :counter="20" :rules="institution.rules.code" />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" flat @click="dlgInstitutionClose">Отмена</v-btn>
              <v-btn color="blue darken-1" flat @click="dlgInstitutionSave" :loading="institution.saving">Сохранить</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    institution: {
      dialog: false,
      valid: false,
      saving: false,
      values: {
        code: '',
        title: '',
        director: '',
        abbreviation: ''
      },
      rules: {
        code: [
          v => !!v || 'Обязательно нужно указать код института',
          v => (v && v.length <= 20) || 'Код института не должен быть длиннее 20 символов'
        ],
        title: [
          v => !!v || 'Обязательно нужно указать название',
          v => (v && v.length <= 255) || 'Название института не должно быть длиннее 255 символов'
        ],
        abbreviation: [
          v => !!v || 'Обязательно нужно указать аббревиаутру',
          v => (v && v.length <= 20) || 'Аббревиатура института не должна быть длиннее 20 символов'
        ]
      }
    },
    headers: [
      {
        text: 'Код института',
        align: 'left',
        sortable: true,
        value: 'code'
      },
      {
        text: 'Полное название',
        align: 'left',
        sortable: true,
        value: 'title'
      },
      {
        text: 'Аббревиатура',
        align: 'left',
        sortable: true,
        value: 'abbreviation'
      },
      {
        text: 'Директор',
        align: 'left',
        sortable: false,
        value: 'director'
      },
      {
        text: '',
        value: null
      }
    ]
  }),
  computed: {
    locale () {
      return this.$i18n.locale
    },
    ...mapState('institutions', {
      institutions: (state) => {
        return Object.values(state.institutions)
      }
    })
  },
  mounted () {
    this.loadInstitutions()
  },
  methods: {
    loadInstitutions () {
      this.$store.dispatch('institutions/getInstitutions').catch((error) => {
        // eslint-disable-next-line
        console.error(error)
      })
    },

    editInstitution (institution) {
      // eslint-disable-next-line
      console.log(institution)
      // this.institution.values = institution
      // this.institution.dialog = true
    },

    dlgInstitutionClose () {
      this.institution.dialog = false
      this.$refs.institutionForm.reset()
    },
    dlgInstitutionSave () {
      if (this.$refs.institutionForm.validate()) {
        this.institution.saving = true
        this.$store.dispatch('institutions/saveInstitution', this.institution.values).then(() => {
          this.$events.$emit('notify', {
            message: 'Институт успешно добавлен',
            type: 'info'
          })
        }).catch((error) => {
          // eslint-disable-next-line
          console.error(error)
        }).finally(() => {
          this.institution.saving = false
          this.dlgInstitutionClose()
        })
      }
    }
  }
}
</script>
